import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'SmartValidation',
    component:  () => import('../components/SmartValidation/SmartValidation.vue'),
    redirect: '/EyeChart',
    children: [
      // Platform ------------------------------------------------------------------------------------ Platform
      {
        path: "/Platform",
        component:  () => import('../views/Platform.vue'),
      },
      // 用户权限 ------------------------------------------------------------------------------------
      {
        path: "/PlatformUser",
        component:  () => import('../views/Platform/UserRights/PlatformUser.vue'),
      },
      {
        path: "/LockerAccess",
        component:  () => import('../views/Platform/UserRights/LockerAccess.vue'),
      },
      {
        path: "/PlatformInstrumentAuthority",
        component:  () => import('../views/Platform/UserRights/PlatformInstrumentAuthority.vue'),
      },
      // 数据字典 ------------------------------------------------------------------------------------
      {
        path: "/Administrative",
        component:  () => import('../views/Platform/DataDictionary/Administrative.vue'),
      },
      {
        path: "/InstrumentModel",
        component:  () => import('../views/Platform/DataDictionary/InstrumentModel.vue'),
      },
      {
        path: "/PipelineType",
        component:  () => import('../views/Platform/DataDictionary/PipelineType.vue'),
      },
      {
        path: "/Tea",
        component:  () => import('../views/Platform/DataDictionary/Tea.vue'),
      },
      {
        path: "/Unit",
        component:  () => import('../views/Platform/DataDictionary/Unit.vue'),
      },
      {
        path: "/UnitCoefficient",
        component:  () => import('../views/Platform/DataDictionary/UnitCoefficient.vue'),
      },
      {
        path: "/WarningCategory",
        component:  () => import('../views/Platform/DataDictionary/WarningCategory.vue'),
      },
      {
        path: "/WarningLevel",
        component:  () => import('../views/Platform/DataDictionary/WarningLevel.vue'),
      },
      {
        path: "/WarningSwitch",
        component:  () => import('../views/Platform/DataDictionary/WarningSwitch.vue'),
      },
      // 数据业务 ------------------------------------------------------------------------------------
      {
        path: "/CustomerManagement",
        component:  () => import('../views/Platform/DataService/CustomerManagement.vue'),
      },
      {
        path: "/MessageManagement",
        component:  () => import('../views/Platform/DataService/MessageManagement.vue'),
      },
      {
        path: "/WarningManagement",
        component:  () => import('../views/Platform/DataService/WarningManagement.vue'),
      },
      {
        path: "/DepartmentManagement",
        component:  () => import('../views/Platform/DataService/DepartmentManagement.vue'),
      },
      {
        path: "/SupplierManagement",
        component:  () => import('../views/Platform/DataService/SupplierManagement.vue'),
      },
      // Smart QC ------------------------------------------------------------------------------------ Smart QC
      {
        path: "/SmartQC",
        component:  () => import('../views/SmartQC.vue'),
      },
      // 用户权限 ------------------------------------------------------------------------------------
      {
        path: "/InstrumentAuthority",
        component:  () => import('../views/SmartQC/UserRights/InstrumentAuthority.vue'),
      },
      {
        path: "/User",
        component:  () => import('../views/SmartQC/UserRights/User.vue'),
      },
      // 流水线 ------------------------------------------------------------------------------------
      {
        path: "/PipelineConfiguration",
        component:  () => import('../views/SmartQC/AssemblyLine/PipelineConfiguration.vue'),
      },
      {
        path: "/PrintBarcode",
        component:  () => import('../views/SmartQC/AssemblyLine/PrintBarcode.vue'),
      },
      // 质控品 ------------------------------------------------------------------------------------
      {
        path: "/QCLotNumber",
        component:  () => import('../views/SmartQC/QC/QCLotNumber.vue'),
      },
      {
        path: "/QCProjectDetails",
        component:  () => import('../views/SmartQC/QC/QCProjectDetails.vue'),
      },
      {
        path: "/QCRule",
        component:  () => import('../views/SmartQC/QC/QCRule.vue'),
      },
      {
        path: "/QCSample",
        component:  () => import('../views/SmartQC/QC/QCSample.vue'),
      },
      // 任务管理 ------------------------------------------------------------------------------------
      {
        path: "/HardwareAlarmMessage",
        component:  () => import('../views/SmartQC/TaskManagement/HardwareAlarmMessage.vue'),
      },
      {
        path: "/HolidayManagement",
        component:  () => import('../views/SmartQC/TaskManagement/HolidayManagement.vue'),
      },
      {
        path: "/RunningTrack",
        component:  () => import('../views/SmartQC/TaskManagement/RunningTrack.vue'),
      },
      {
        path: "/RunTask",
        component:  () => import('../views/SmartQC/TaskManagement/RunTask.vue'),
      },
      // 结果管理 ------------------------------------------------------------------------------------
      {
        path: "/QCResult",
        component:  () => import('../views/SmartQC/ResultManagement/QCResult.vue'),
      },
      {
        path: "/QCStatus",
        component:  () => import('../views/SmartQC/ResultManagement/QCStatus.vue'),
      },
      // 图形管理 ------------------------------------------------------------------------------------
      {
        path: "/HR",
        component:  () => import('../views/SmartQC/GraphicsManagement/HR.vue'),
      },
      {
        path: "/HRC",
        component:  () => import('../views/SmartQC/GraphicsManagement/HRC.vue'),
      },
      {
        path: "/HRE",
        component:  () => import('../views/SmartQC/GraphicsManagement/HRE.vue'),
      },
      {
        path: "/HRM",
        component:  () => import('../views/SmartQC/GraphicsManagement/HRM.vue'),
      },
      {
        path: "/IQCChart",
        component:  () => import('../views/SmartQC/GraphicsManagement/IQCChart.vue'),
      },
      {
        path: "/PedEvaluation",
        component:  () => import('../views/SmartQC/GraphicsManagement/PedEvaluation.vue'),
      },
      {
        path: "/ProcessSigma",
        component:  () => import('../views/SmartQC/GraphicsManagement/ProcessSigma.vue'),
      },
      {
        path: "/RealTimeEQC",
        component:  () => import('../views/SmartQC/GraphicsManagement/RealTimeEQC.vue'),
      },
      {
        path: "/SixSigma",
        component:  () => import('../views/SmartQC/GraphicsManagement/SixSigma.vue'),
      },
      {
        path: "/SixSigmaPro",
        component:  () => import('../views/SmartQC/GraphicsManagement/SixSigmaPro.vue'),
      },
      {
        path: "/HRadmin",
        component:  () => import('../views/SmartQC/GraphicsManagement/HRadmin.vue'),
      },
      // 基础数据 ------------------------------------------------------------------------------------
      {
        path: "/BatchNumberTest",
        component:  () => import('../views/SmartQC/BasicData/BatchNumberTest.vue'),
      },
      {
        path: "/QCCategory",
        component:  () => import('../views/SmartQC/BasicData/QCCategory.vue'),
      },
      {
        path: "/QCDataProcessing",
        component:  () => import('../views/SmartQC/BasicData/QCDataProcessing.vue'),
      },
      {
        path: "/LotLevelItem",
        component:  () => import('../views/SmartQC/BasicData/LotLevelItem.vue'),
      },
      {
        path: "/QCLotNumberBasicData",
        component:  () => import('../views/SmartQC/BasicData/QCLotNumberBasicData.vue'),
      },
      {
        path: "/QCManufacturer",
        component:  () => import('../views/SmartQC/BasicData/QCManufacturer.vue'),
      },
      {
        path: "/ReagentManufacturer",
        component:  () => import('../views/SmartQC/BasicData/ReagentManufacturer.vue'),
      },
      {
        path: "/TestName",
        component:  () => import('../views/SmartQC/BasicData/TestName.vue'),
      },
      // 质控报告 ------------------------------------------------------------------------------------
      {
        path: "/QCReport",
        component:  () => import('../views/SmartQC/QCReport/QCReport.vue'),
      },
      {
        path: "/QCMasterList",
        component:  () => import('../views/SmartQC/QCReport/QCMasterList.vue'),
      },
      {
        path: "/ReagentBatchReport",
        component:  () => import('../views/SmartQC/QCReport/ReagentBatchReport.vue'),
      },
      {
        path: "/RunawayReport",
        component:  () => import('../views/SmartQC/QCReport/RunawayReport.vue'),
      },
      // 性能验证 ------------------------------------------------------------------------------------ 性能验证
      {
        path: "/PerformanceVerification",
        component:  () => import('../views/PerformanceVerification.vue'),
      },
      // 性能验证 ------------------------------------------------------------------------------------
      {
        path: "/MethodsCompare",
        component:  () => import('../views/PerformanceVerification/PerformanceVerification/MethodsCompare.vue')
      },
      {
        path: "/Precision",
        component:  () => import('../views/PerformanceVerification/PerformanceVerification/Precision.vue')
      },
      {
        path: "/Linear",
        component:  () => import('../views/PerformanceVerification/PerformanceVerification/Linear.vue')
      },
      {
        path: "/DilutionVerification",
        component:  () => import('../views/PerformanceVerification/PerformanceVerification/DilutionVerification.vue')
      },
      {
        path: "/ReferenceIntervalVerification",
        component:  () => import('../views/PerformanceVerification/PerformanceVerification/ReferenceIntervalVerification.vue')
      },
      // CRM ------------------------------------------------------------------------------------ CRM
      {
        path: "/CRM",
        component:  () => import('../views/CRM.vue'),
      },
      // 订单管理 ------------------------------------------------------------------------------------
      {
        path: "/OrderInquiry",
        component:  () => import('../views/CRM/OrderManagement/OrderInquiry.vue'),
      },
      // 基础数据 ------------------------------------------------------------------------------------
      {
        path: "/QuestionnaireManagement",
        component:  () => import('../views/CRM/BasicData/QuestionnaireManagement.vue'),
      },
      {
        path: "/QuestionnaireQuestion",
        component:  () => import('../views/CRM/BasicData/QuestionnaireQuestion.vue'),
      },
      // 用户管理 ------------------------------------------------------------------------------------
      {
        path: "/UserCRM",
        component:  () => import('../views/CRM/UserManagement/UserCRM.vue'),
      },
      // 客户管理 ------------------------------------------------------------------------------------
      {
        path: "/Customer",
        component:  () => import('../views/CRM/CustomerManagement/Customer.vue'),
      },
      // 检测产品 ------------------------------------------------------------------------------------
      {
        path: "/TestProduct",
        component:  () => import('../views/CRM/TestProduct/TestProduct.vue'),
      },
      // SPD ------------------------------------------------------------------------------------ SPD
      {
        path: "/SPD",
        component:  () => import('../views/SPD.vue'),
      },
      // 业务数据 ------------------------------------------------------------------------------------
      {
        path: "/AlarmSetting",
        component:  () => import('../views/SPD/ServiceData/AlarmSetting.vue'),
      },
      {
        path: "/MaterialLotNumber",
        component:  () => import('../views/SPD/ServiceData/MaterialLotNumber.vue'),
      },
      {
        path: "/MaterialManagement",
        component:  () => import('../views/SPD/ServiceData/MaterialManagement.vue'),
      },
      {
        path: "/StockPlan",
        component:  () => import('../views/SPD/ServiceData/StockPlan.vue'),
      },
      // 仓库管理 ------------------------------------------------------------------------------------
      {
        path: "/Warehousing",
        component:  () => import('../views/SPD/WarehouseManagement/Warehousing.vue'),
      },
      {
        path: "/WarehouseMaintenance",
        component:  () => import('../views/SPD/WarehouseManagement/WarehouseMaintenance.vue'),
      },
      {
        path: "/Warehouse",
        component:  () => import('../views/SPD/WarehouseManagement/Warehouse.vue'),
      },
      {
        path: "/Outbound",
        component:  () => import('../views/SPD/WarehouseManagement/Outbound.vue'),
      },
      {
        path: "/MaterialDetail",
        component:  () => import('../views/SPD/WarehouseManagement/MaterialDetail.vue'),
      },
      {
        path: "/Listing",
        component:  () => import('../views/SPD/WarehouseManagement/Listing.vue'),
      },
      {
        path: "/Delist",
        component:  () => import('../views/SPD/WarehouseManagement/Delist.vue'),
      },
      {
        path: "/CheckStock",
        component:  () => import('../views/SPD/WarehouseManagement/CheckStock.vue'),
      },
      {
        path: "/Initialize",
        component:  () => import('../views/SPD/WarehouseManagement/Initialize.vue'),
      },
      // 系统预警 ------------------------------------------------------------------------------------
      {
        path: "/AlarmMessage",
        component:  () => import('../views/SPD/SystemAlarm/AlarmMessage.vue'),
      },
      {
        path: "/InventoryWarning",
        component:  () => import('../views/SPD/SystemAlarm/InventoryWarning.vue'),
      },
      {
        path: "/TemperatureMonitoring",
        component:  () => import('../views/SPD/SystemAlarm/TemperatureMonitoring.vue'),
      },
      {
        path: "/ValidityWarning",
        component:  () => import('../views/SPD/SystemAlarm/ValidityWarning.vue'),
      },
      // 基础数据 ------------------------------------------------------------------------------------
      {
        path: "/LockerManufacturers",
        component:  () => import('../views/SPD/BasicData/LockerManufacturers.vue'),
      },
      {
        path: "/LockerModelNumber",
        component:  () => import('../views/SPD/BasicData/LockerModelNumber.vue'),
      },
      {
        path: "/MaterialBasicData",
        component:  () => import('../views/SPD/BasicData/MaterialBasicData.vue'),
      },
      {
        path: "/MaterialManufacturer",
        component:  () => import('../views/SPD/BasicData/MaterialManufacturer.vue'),
      },
      {
        path: "/MaterialType",
        component:  () => import('../views/SPD/BasicData/MaterialType.vue'),
      },
      {
        path: "/MaterialUnit",
        component:  () => import('../views/SPD/BasicData/MaterialUnit.vue'),
      },
      {
        path: "/TemperatureControlType",
        component:  () => import('../views/SPD/BasicData/TemperatureControlType.vue'),
      },
      // 结果互认 ------------------------------------------------------------------------------------
      {
        path: "/MutualRecognitionOfResults",
        component:  () => import('../views/MutualRecognitionOfResults.vue'),
      },

      // 【Eye Chart】 ------------------------------------------------------------------------------------
      {
        path: "/EyeChart",
        component:  () => import('../views/EyeChart.vue'),
      },
      // 年级视力等级 ------------------------------------------------------------------------------------
      {
        path: "/gradeSightLevel",
        component:  () => import('../views/EyeChart/GradeSightLevel.vue'),
      },
      // 班级视力等级 ------------------------------------------------------------------------------------
      {
        path: "/classSightLevel",
        component:  () => import('../views/EyeChart/ClassSightLevel.vue'),
      },
      // 视力查询 ------------------------------------------------------------------------------------
      {
        path: "/studentSightList",
        component:  () => import('../views/EyeChart/StudentSightSearch.vue'),
      },
      // 视力变化曲线 ------------------------------------------------------------------------------------
      {
        path: "/studentSightHistory",
        component:  () => import('../views/EyeChart/StudentSightHistory.vue'),
      },
      // 班级学生视力排行 ------------------------------------------------------------------------------------
      {
        path: "/studentSightLeaderboard",
        component:  () => import('../views/EyeChart/StudentSightLeaderboard.vue'),
      },
      // 班级视力率排行 ------------------------------------------------------------------------------------
      {
        path: "/classMyopiaRate",
        component:  () => import('../views/EyeChart/ClassMyopiaRate.vue'),
      },
      // 年级视力率排行 ------------------------------------------------------------------------------------
      {
        path: "/gradeMyopiaRate",
        component:  () => import('../views/EyeChart/GradeMyopiaRate.vue'),
      },
      // 校级性别视力率排行 ------------------------------------------------------------------------------------
      {
        path: "/schoolSexPercent",
        component:  () => import('../views/EyeChart/SchoolSexPercent.vue'),
      },
      // 年级性别视力率排行 ------------------------------------------------------------------------------------
      {
        path: "/gradeSexPercent",
        component:  () => import('../views/EyeChart/GradeSexPercent.vue'),
      },
      // 年龄段近视率 ------------------------------------------------------------------------------------
      {
        path: "/agePercent",
        component:  () => import('../views/EyeChart/AgePercent.vue'),
      },
      // 学校管理 ------------------------------------------------------------------------------------
      {
        path: "/settingSchool",
        component:  () => import('../views/EyeChart/SchoolManagement.vue'),
      },
      // 用户权限-学校配置 ------------------------------------------------------------------------------------
      {
        path: "/settingUserAuthor",
        component:  () => import('../views/EyeChart/UserAuthor.vue'),
      },
      // 用户权限-学生查询 ------------------------------------------------------------------------------------
      {
        path: "/studentInformation",
        component:  () => import('../views/EyeChart/StudentInformation.vue'),
      },
      // 系统配置-批次维护 ------------------------------------------------------------------------------------
      {
        path: "/lotNumberMaintenance",
        component:  () => import('../views/EyeChart/LotNumberMaintenance.vue'),
      },
      {
        path: "/videoManage",
        component:  () => import('../views/EyeChart/VideoManage.vue'),
      },
      {
        path: "/messageGroup",
        component:  () => import('../views/EyeChart/MessageGroup.vue'),
      },
      {
        path: "/sendMessageManagement",
        component:  () => import('../views/EyeChart/SendMessageManagement.vue'),
      },
      {
        path: "/messageTemplate",
        component:  () => import('../views/EyeChart/MessageTemplate.vue'),
      },
      // 订单管理 ------------------------------------------------------------------------------------
      // 订单管理 - 订单列表
      {
        path: "/orderList",
        component:  () => import('../views/EyeChart/OrderManagement.vue'),
      },
      // 眼科诊断 - 诊断列表
      {
        path: "/diagnosticList",
        component:  () => import('../views/EyeChart/EyeDiagnosis.vue'),
      },
      // 配镜管理 - 配镜列表
      {
        path: "/glassesList",
        component:  () => import('../views/EyeChart/GlassesManagement.vue'),
      },
      // 近视统计-年龄段近视率
      {
        path: "/ageAnalysis",
        component:  () => import('../views/EyeChart/AgeAnalysis.vue'),
      },
      // 近视统计-性别近视率
      {
        path: "/sexAnalysis",
        component:  () => import('../views/EyeChart/SexAnalysis.vue'),
      },
      // 近视统计-近视率排行
      {
        path: "/myopiaRateAnalysis",
        component:  () => import('../views/EyeChart/MyopiaRateAnalysis.vue'),
      },
      // 近视统计-实力等级占比
      {
        path: "/levelRateAnalysis",
        component:  () => import('../views/EyeChart/LevelRateAnalysis.vue'),
      },

      // 【Five Health Chart】 ------------------------------------------------------------------------------------
      // 体重筛查
      {
        path: "/weightScreening",
        component:  () => import('../views/FiveHealth/weightScreening.vue'),
      },
      {
        path: "/weightAnalysis",
        component:  () => import('../views/FiveHealth/Weight.vue'),
      },
      // 身高体重分布图
      {
        path: "/heightWeightChart",
        component:  () => import('../views/FiveHealth/heightWeightChart.vue'),
      },
      // 口腔筛查
      {
        path: "/oralScreening",
        component:  () => import('../views/FiveHealth/oralScreening.vue'),
      },
      // 口腔
      {
        path: "/oralAnalysis",
        component:  () => import('../views/FiveHealth/oralHealth.vue'),
      },
      // 脊柱
      {
        path: "/boneScreening",
        component:  () => import('../views/FiveHealth/boneScreening.vue'),
      },
      // 脊柱
      {
        path: "/boneAnalysis",
        component:  () => import('../views/FiveHealth/boneHealth.vue'),
      },
      // 心理筛查
      {
        path: "/mentalScreening",
        component:  () => import('../views/FiveHealth/mentalScreening.vue'),
      },
      // 心理
      {
        path: "/mentalAnalysis",
        component:  () => import('../views/FiveHealth/mentalHealth.vue'),
      },
      // 健康档案
      {
        path: "/studentDocument",
        component:  () => import('../views/FiveHealth/studentDocument.vue'),
      },
      // 数据比例
      {
        path: "/dataAnalysisPie",
        component:  () => import('../views/FiveHealth/dataAnalysisPie.vue'),
      },
      // 健康比例折线图
      {
        path: "/healthRateLine",
        component:  () => import('../views/FiveHealth/healthRateLine.vue'),
      },
    ]
  },
  {
    path: "/login",
    component:  () => import('../views/Login.vue')
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})


//解决重复点击导航时，控制台报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
